if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector(
            '[id^="GalleryStatus"]'
          ),
          viewer: this.querySelector(
            '[id^="GalleryViewer"]'
          ),
          thumbnails: this.querySelector(
            '[id^="GalleryThumbnails"]'
          ),
        };

        this.mql = window.matchMedia(
          '(min-width: 750px)'
        );

        if (!this.elements.viewer) return;

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(
            this.onSlideChanged.bind(this),
            200
          )
        );

        if (this.elements.thumbnails) {
          this.elements.thumbnails
            .querySelectorAll('[data-target]')
            .forEach((mediaToSwitch) => {
              const button =
                mediaToSwitch.querySelector(
                  'button'
                );

              if (!button) return;

              button.addEventListener(
                'click',
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false
                )
              );
            });
        }

        if (
          this.dataset.desktopLayout &&
          this.dataset.desktopLayout.includes(
            'thumbnail'
          ) &&
          this.mql.matches
        ) {
          this.removeListSemantic();
        }

        /*
         * NO custom touchstart/touchmove/touchend.
         * Dawn's native slider handles mobile swiping.
         */
      }

      onSlideChanged(event) {
        if (!this.elements.thumbnails) return;

        const currentElement =
          event.detail?.currentElement;

        if (!currentElement) return;

        const thumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${currentElement.dataset.mediaId}"]`
          );

        if (thumbnail) {
          this.setActiveThumbnail(thumbnail);
        }
      }

      setActiveMedia(mediaId, prepend) {
        if (!this.elements.viewer) return;

        const activeMedia =
          this.elements.viewer.querySelector(
            `[data-media-id="${mediaId}"]`
          ) ||
          this.elements.viewer.querySelector(
            '[data-media-id]'
          );

        if (!activeMedia) return;

        this.elements.viewer
          .querySelectorAll('[data-media-id]')
          .forEach((element) => {
            element.classList.remove(
              'is-active'
            );
          });

        activeMedia.classList.add(
          'is-active'
        );

        /*
         * Variant media reorder.
         */
        if (prepend) {
          if (
            activeMedia.parentElement &&
            activeMedia.parentElement.firstChild !==
              activeMedia
          ) {
            activeMedia.parentElement.prepend(
              activeMedia
            );
          }

          if (this.elements.thumbnails) {
            const activeThumbnail =
              this.elements.thumbnails.querySelector(
                `[data-target="${mediaId}"]`
              );

            if (
              activeThumbnail &&
              activeThumbnail.parentElement &&
              activeThumbnail.parentElement.firstChild !==
                activeThumbnail
            ) {
              activeThumbnail.parentElement.prepend(
                activeThumbnail
              );
            }
          }

          if (this.elements.viewer.slider) {
            this.elements.viewer.resetPages();
          }
        }

        this.preventStickyHeader();

        /*
         * Move the MAIN gallery to the selected media.
         * This is horizontal scrolling only.
         */
        if (activeMedia.parentElement) {
          activeMedia.parentElement.scrollTo({
            left: activeMedia.offsetLeft,
            behavior: 'smooth',
          });
        }

        /*
         * CLOTHPIC:
         * Variant media change -> page top.
         *
         * Only prepend=true runs this.
         *
         * Swipe / thumbnail click / gallery arrow
         * do not run it.
         */
        if (prepend) {
          window.setTimeout(() => {
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: 'smooth',
            });
          }, 250);
        }

        this.playActiveMedia(
          activeMedia
        );

        if (!this.elements.thumbnails) return;

        const activeThumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );

        if (!activeThumbnail) return;

        this.setActiveThumbnail(
          activeThumbnail
        );

        if (this.elements.liveRegion) {
          this.announceLiveRegion(
            activeMedia,
            activeThumbnail.dataset
              .mediaPosition
          );
        }
      }

      setActiveThumbnail(thumbnail) {
        if (
          !this.elements.thumbnails ||
          !thumbnail
        ) {
          return;
        }

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((button) => {
            button.removeAttribute(
              'aria-current'
            );
          });

        const button =
          thumbnail.querySelector(
            'button'
          );

        if (button) {
          button.setAttribute(
            'aria-current',
            'true'
          );
        }

        if (
          typeof this.elements.thumbnails
            .isSlideVisible ===
            'function' &&
          this.elements.thumbnails.isSlideVisible(
            thumbnail,
            10
          )
        ) {
          return;
        }

        if (
          this.elements.thumbnails.slider
        ) {
          this.elements.thumbnails.slider.scrollTo({
            left: thumbnail.offsetLeft,
            behavior: 'smooth',
          });
        }
      }

      announceLiveRegion(
        activeItem,
        position
      ) {
        if (!this.elements.liveRegion) return;

        const image =
          activeItem.querySelector(
            '.product__modal-opener--image img'
          );

        if (!image) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute(
            'aria-hidden',
            'false'
          );

          if (
            window.accessibilityStrings &&
            window.accessibilityStrings
              .imageAvailable
          ) {
            this.elements.liveRegion.innerHTML =
              window.accessibilityStrings
                .imageAvailable.replace(
                  '[index]',
                  position
                );
          }

          window.setTimeout(() => {
            this.elements.liveRegion.setAttribute(
              'aria-hidden',
              'true'
            );
          }, 2000);
        };

        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        if (
          typeof window.pauseAllMedia ===
          'function'
        ) {
          window.pauseAllMedia();
        }

        const deferredMedia =
          activeItem.querySelector(
            '.deferred-media'
          );

        if (deferredMedia) {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader ||
          document.querySelector(
            'sticky-header'
          );

        if (!this.stickyHeader) return;

        this.stickyHeader.dispatchEvent(
          new Event(
            'preventHeaderReveal'
          )
        );
      }

      removeListSemantic() {
        if (
          !this.elements.viewer ||
          !this.elements.viewer.slider
        ) {
          return;
        }

        this.elements.viewer.slider.setAttribute(
          'role',
          'presentation'
        );

        this.elements.viewer.sliderItems.forEach(
          (slide) => {
            slide.setAttribute(
              'role',
              'presentation'
            );
          }
        );
      }
    }
  );
}